import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import DatePicker from 'vue2-datepicker'

export default {
	name: 'surface-cargo-mapping',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading,
		DatePicker
	},
	props: [],
	data() {
		return {
			hubzoneLoading: '',
			isLoading: false,
			isLoadingSearch: false,
			activeHubList: [],
			HubDetails: [],
			hublist: [],
			hubitem: {
				value: '',
				text: ''
			},
			hub: '',
			hubLoading: '',
			createdby: '',
			pageSize: 10,
			pageIndex: 1,
			pageCount: 0,
			hubzonelist: [],
			hubzoneitem: {
				id: '',
				text: ''
			},
			hubzone: '',
			listHubZoneData: [],
			listHubZoneObjDataFlt2: {
				id: '',
				text: ''
			},
			hubzoneidflt2: '',
			listDestHubNameListForFilter: [],
			listDestNameDataObj2: {
				id: '',
				text: ''
			},
			destHubID: '',
			centerType:'',
			isRTO:'',
			shippingId:'',
			gapHours:'',
			validDateRange:'',
			validDateRangeFrom:'',
			FromDate: '',
      ToDate: '',
			todaysDate:new Date(),
			invalidTokenModal: false,
      invalidtokenmsg: '',
			comparator:'',
			hubID:'',
			totalCount:-1,
			inscanBagInPendingList:[],
			hubNames:[]
		}
	},
	computed: {},
	filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdby = userdetail[0].email
		this.getHubZone();
		this.getHubName();
	},
	methods: {
		getHubName() {
      this.hublist = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hubNames.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },
		checkToDate() {
			var date1 = new Date(this.FromDate);
			date1.setDate(date1.getDate() + 14)
			if(date1>=this.todaysDate){
				this.validDateRange = this.todaysDate
			}else{
				this.validDateRange = date1
			}
		},
		checkFromDate() {
			var date2 = new Date(this.ToDate);
			date2.setDate(date2.getDate() - 14)
			this.validDateRangeFrom = date2
		},

		selectedHubZoneFlt2(hubData) {
			this.listHubZoneObjDataFlt2 = hubData
			this.hubzoneidflt2 = hubData.id;
			if (this.hubzoneidflt2 != undefined) {
				this.getDestinationHubNameListForFilter(this.hubzoneidflt2)
			}
		},

		selectedDestHubName(selectedData) {
			this.listDestNameDataObj2 = selectedData
			this.destHubID = selectedData.value;
		},

		getDestinationHubNameListForFilter(data) {
			this.hubLoading = 'Loading Hub...'
			this.listDestHubNameListForFilter = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: data,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var listDestHubNameListForFilter = result.data.ResponseData;
					for (i = 0; i < listDestHubNameListForFilter.length; i++) {
						this.listDestHubNameListForFilter.push({
							value: listDestHubNameListForFilter[i].HubID,
							text: listDestHubNameListForFilter[i].HubCode + ' - ' + listDestHubNameListForFilter[i].HubName + ' (' + listDestHubNameListForFilter[i].HubID + ')',
							text1: listDestHubNameListForFilter[i].HubName,
							hubcode: listDestHubNameListForFilter[i].HubCode
						})
					}
				}, error => {
					console.error(error)
				})
		},

		getHubZone() {
			this.hubzoneLoading = 'Loading Hub Zone...'
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				// hubName: this.hubzoneitem.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubzoneLoading = ''
					this.HubZoneListData = result.data.ResponseData;
					for (i = 0; i < this.HubZoneListData.length; i++) {
						this.hubzonelist.push({
							id: this.HubZoneListData[i].hubzoneid,
							text: this.HubZoneListData[i].hubzonename
						})
					}
				}, error => {
					console.error(error)
				})
		},

		selectHubZone(hubzoneitem) {
			this.hubzoneitem = hubzoneitem
			this.hubzone = this.hubzoneitem.text
			this.hubzoneid = this.hubzoneitem.id

			if (this.hubzoneid != undefined) {
				this.getHubList(this.hubzoneid)
			}
		},

		getHubList() {
			this.hublist=[]
			this.hubitem={}
			this.hubLoading = 'Loading Hub...'
			this.input = ({
				hubZoneId: this.hubzoneid,
				// centerType:this.centerType
			})
			if(this.centerType){
				this.input.centerType=this.centerType
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					this.HubDetails = []
					for (var i = 0; i < result.data.ResponseData.length; i++) {
						this.hublist.push({
							"value": result.data.ResponseData[i].HubID,
							"text": result.data.ResponseData[i].HubName + '(' + result.data.ResponseData[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},

		selectHub(hubitem) {
			this.hubitem = hubitem
			this.hub = hubitem.text
			this.hubID = hubitem.value
		},
		getCount() {
		this.totalCount=-1
		this.inscanBagInPendingList=[]
		this.pageIndex=1
		this.isLoading=true
		this.input = ({
				"currentHubId":this.hubID,
		    "finalDestinationId" : this.destHubID,
		    "shippingId" : this.shippingId,
		    "showRTO" : this.isRTO,
		    "gapHours" : this.gapHours,
		    "comparator" : this.comparator,
				"fromDate" : moment(this.FromDate).format('YYYY-MM-DD'),
		    "toDate" :moment(this.ToDate).format('YYYY-MM-DD')
		})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'inscanDoneBaginPendingCount',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'token': this.token
					}
				})
				.then(result => {
					this.isLoading=false
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.totalCount=result.data.TotalCount
					} else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
						this.invalidTokenModal = false
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoading=false
					console.error(error)
				})
		},
		getReport() {
			this.isLoadingSearch=true
		this.input = ({
				"currentHubId":this.hubID,
				"finalDestinationId" : this.destHubID,
				"shippingId" : this.shippingId,
				"showRTO" : this.isRTO,
				"gapHours" : this.gapHours,
				"comparator" : this.comparator,
				"fromDate" : moment(this.FromDate).format('YYYY-MM-DD'),
				"toDate" :moment(this.ToDate).format('YYYY-MM-DD'),
				"pageIndex":this.pageIndex,
				"pageSize":this.pageSize
		})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'inscanDoneBaginPendingDetails',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'token': this.token
					}
				})
				.then(result => {
					this.isLoadingSearch=false
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						var hubDetails =[]
						var resultData=[]
						for (var i = 0; i < this.hubNames.length; i++) {
							hubDetails[this.hubNames[i].value] = this.hubNames[i].text;
						}
						result.data.Result.forEach(function(item) {
							item["OriginHubName"] = '';
							if (item.originHubId && hubDetails[item.originHubId]) {
								item["OriginHubName"] = hubDetails[item.originHubId];
							}
							item["CurrentLocationName"] = '';
							if (item.currentHubId && hubDetails[item.currentHubId]) {
								item["CurrentLocationName"] = hubDetails[item.currentHubId];
							}
							item["FinalDestinationName"] = '';
							if (item.finalDestinationHubId && hubDetails[item.finalDestinationHubId]) {
								item["FinalDestinationName"] = hubDetails[item.finalDestinationHubId];
							}
							resultData.push(item);
						});
						this.inscanBagInPendingList = resultData
						if (this.totalCount < 10) {
							this.pageCount = 1
						} else {
							this.pageCount = Math.ceil(this.totalCount / 10);
						}
						let tabcontent=document.getElementById("tabcontent");
						tabcontent.scrollIntoView({ behavior: 'smooth', block: 'end' });
						// this.$alertify.success(result.data.ReturnMessage)
					}  else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          }else {
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoadingSearch=false
					console.error(error)
				})
		},
		getPaginationData(pageNum) {
			this.pageIndex = (pageNum)
			this.getReport()
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
					this.getCount();
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		resetForm(){
			this.hubzoneLoading= '',
			this.isLoading= false,
			this.isLoadingSearch= false,
			this.activeHubList= [],
			this.HubDetails= [],
			this.hublist= [],
			this.hubzoneidflt2=''
			this.listHubZoneObjDataFlt2= {
				id: '',
				text: ''
			}
			this.hubitem= {
				value: '',
				text: ''
			},
			this.hub= '',
			this.hubLoading= '',
			this.pageCount= 0,
			this.pageNo= 0,
			this.hubzoneitem= {
				id: '',
				text: ''
			},
			this.hubzone= '',
			this.listDestHubNameListForFilter= [],
			this.listDestNameDataObj2= {
				id: '',
				text: ''
			},
			this.destHubID= '',
			this.centerType='',
			this.isRTO='',
			this.shippingId='',
			this.gapHours=''
			this.FromDate= '',
      this.ToDate= ''
			this.totalCount=-1
			this.pageIndex=1
			this.inscanBagInPendingList=[]
			this.hubID=''
			this.comparator=''
			this.validDateRange=''
			this.validDateRangeFrom=''
			this.validDateRangeFrom =''
			window.scrollTo(0,0)
			this.$validator.reset();
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/InscanDoneBagInPendingReport/InscanDoneBagInPendingReport.js